import { useCallback, useEffect } from 'react'
import { trackEvent } from '@mc/track-event'
import { useHelpCenterEvents } from './helpCenterEvents'

export const useTracking = () => {
  const { subscribe } = useHelpCenterEvents()

  const track = useCallback((event: string, extraParams = {}) => {
    trackEvent(event, {
      // Override since it is not relevant nor reliable for the help center.
      // Users could be coming from all sorts of products and NextJs always sends false.
      active_annual_pass: undefined,
      ...extraParams,
    })
  }, [])

  useEffect(
    () =>
      subscribe('click', ({ location, action, href }) => {
        track('Help Center Click', {
          location,
          action,
          href,
        })
      }),
    [subscribe, track],
  )

  useEffect(
    () =>
      subscribe('modalViewed', ({ modalType }) => {
        track('Help Center Modal Viewed', {
          modal_type: modalType,
        })
      }),
    [subscribe, track],
  )

  useEffect(
    () =>
      subscribe('search', ({ search }) => {
        track('Help Center Search', { search })
      }),
    [subscribe, track],
  )
}

export const Tracker = () => {
  useTracking()

  return null
}
